module.exports = __webpack_public_path__ + "media/Tu4yrA4JFn-cropped.01b909b3.mp4";